// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:26
import { QueryPart_abstract } from './../../abstract/SagaBase/Objects/QueryPart_abstract';
export class QueryPart extends QueryPart_abstract {}
